export default {
	showChangePassword: false,
}
